import { Icon } from "@components/icon";
import cx from "classnames";
import React, { type ButtonHTMLAttributes, type FC } from "react";

interface ButtonWithLoaderProps extends ButtonHTMLAttributes<HTMLInputElement> {
  loading: boolean;
  secondary?: boolean;
}

const ButtonWithLoader: FC<ButtonWithLoaderProps> = ({
  loading,
  className,
  secondary,
  ...rest
}) => {
  const classNames = cx(className, { secondary });
  return (
    <div
      className={cx("button-with-loader", {
        "button-with-loader--loading": loading,
      })}
    >
      <input className={classNames} type="submit" {...rest} />
      {loading ? (
        <Icon
          className="button-with-loader--icon"
          name="loop2"
          ariaLabel="Loading..."
        />
      ) : null}
    </div>
  );
};

export { ButtonWithLoader, type ButtonWithLoaderProps };
